export const APP_SETTINGS = {
  layout: '',
  container: 'fixed',
  ui: {
    // null = keine eigene Wahl des Benutzers -> Firmen-Standard
    // (organisation_themes.custom_variables.background_animation), sonst 'particles'.
    // Werte: 'none' | 'particles' | 'aurora' | 'starfield' | 'orbs' | 'vortex' | 'dna' | 'crystals' | 'hexgrid' | 'grid' | 'matrix'
    backgroundAnimation: null,
  },
  features: {
    telegramChat: {
      enabled: false,
      pollIntervalMs: 8000,
    },
  },
  layouts: {
    xoffi: {
      sidebarCollapse: false,
      sidebarTheme: 'light',
      headerSticky: true,
      headerStickyOffset: 0,
      responsiveBreakpoint: 1024,
      sidebarWidth: 275,
      sidebarCollapsedWidth: 70,
      headerHeight: 70,
      footerHeight: 60,
    },
    demo1: {
      sidebarCollapse: false,
      sidebarTheme: 'light',
    },
    demo2: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo5: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo7: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
    demo9: {
      headerSticky: true,
      headerStickyOffset: 200,
    },
  },
};
